import { useQuery } from '@tanstack/react-query';

import type { DecompositionNode } from 'api/data/projects/types';

import { treeQueryKeys } from '../utils/treeQueryKeys';

const EMPTY_STICKY_NODES: DecompositionNode[] = [];

export function useStickyTopNodes(
  projectId: string,
  templateNodeId: string,
  proposalId?: string,
  parentDataNodeId?: string
): DecompositionNode[] {
  const { data } = useQuery<DecompositionNode[]>({
    queryKey: treeQueryKeys.stickyTop({ projectId, templateNodeId, proposalId }, parentDataNodeId),
    queryFn: () => Promise.resolve<DecompositionNode[]>([]),
    enabled: false,
    initialData: () => [],
    staleTime: Infinity,
    gcTime: Infinity
  });
  return data ?? EMPTY_STICKY_NODES;
}
